import { useAppConfigs } from '@config/config.hooks';
import { envConfigs } from '@config/envConfigs';
import { AzureLoginLogoutButton, Button, ComponentType, ILoggedInUser } from '@gcl/react-core';
import { useNavigate } from '@routes/routes.hooks';
import { routes } from '@routes/routes.models';
import * as React from 'react';
import { identifyUser } from './dynatrace.services';
import './requireLogin.scss';

export interface IRequireLoginProps {}

export const RequireLogin: React.FC<IRequireLoginProps> = ({}) => {
  const appConfigs = useAppConfigs();
  const { navigate } = useNavigate();

  return (
    <div className="gcl-gems-require-login-container">
      <div className="gcl-gems-require-login-content">
        <div className="gcl-gems-require-login-logo">
          <img alt="gammon-logo" src="https://logo.gammonconstruction.com/Icon_R.png" className="gcl-mr-sm" />
          <img alt="gems-logo" src="/images/gems-logo.png" width="auto" />
        </div>
        <div className="gcl-gems-require-login-text">
          <b className="gcl-fs-md">Login now to start using GEMS</b>
          <br /> Gammon Engineering Management System
        </div>
        <AzureLoginLogoutButton
          scopes={[envConfigs.apiScope as string]}
          onUserLoggedIn={(user: ILoggedInUser) => {
            appConfigs.updateConfigs?.((configs) => {
              return { ...configs, loggedInUser: user };
            });

            identifyUser(user.username || '');
            navigate(routes.home.path);
          }}
          validateIssuers={(issuer) => {
            if (!envConfigs?.validIssuers) return true;
            return envConfigs.validIssuers.split(',').some((validIssuer) => {
              // issuer format 'https://login.microsoftonline.com/{tenantId}/v2.0
              return issuer.includes(validIssuer);
            });
          }}
          render={(isLoggedIn, onClickLoginLogoutBtn, accounInfo, imageSrc) => {
            return !isLoggedIn ? (
              <Button
                style={{ margin: '0 auto 10px auto' }}
                className="gcl-clickable"
                onClick={onClickLoginLogoutBtn}
                type={ComponentType.Primary}
                prefixIconName="Microsoft"
              >
                <span>Sign In</span>
              </Button>
            ) : null;
          }}
        />
      </div>
    </div>
  );
};
